import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

import mainLogo from './assets/logo/aialgorithm.png'
import mainLogoBlack from './assets/logo/aialgorithm-black.png'
import snggLogo from './assets/logo/jjh.png'
import fxLogoWhite from './assets/logo/fx-white.png'
import ccidLogo from './assets/logo/ccid.png'
import cciaLogo from './assets/logo/ccia.png'
import ccidLogoRed from './assets/logo/ccid-red.jpg'
import cocoLogo from './assets/logo/coco.png'
import raicLogo from './assets/logo/raic.png'
import hsjyLogo from './assets/logo/hsjy.png'
import zqckLogo from './assets/logo/zqck.png'
import ksLogo from './assets/logo/ks.png'
import mbbLogo from './assets/logo/mbb.png'
import rmwpLogo from './assets/logo/rmwp.png'
import ywLogo from './assets/logo/yw.png'
import tlLogo from './assets/logo/tl.png'
import qmxLogo from './assets/logo/qmx.png'

import detailImg0 from './assets/image/frontpage/detail0.jpg'
import detailImg1 from './assets/image/frontpage/detail1.jpg'
import detailImg2 from './assets/image/frontpage/detail2.jpg'

import detailImg3 from './assets/image/frontpage/detail3.png'
import detailImg4 from './assets/image/frontpage/detail4.jpg'
import detailImg5 from './assets/image/frontpage/detail5.jpg'

import groupS1 from './assets/image/enroll/group-s1.png'
import groupS2 from './assets/image/enroll/group-s2.png'
import groupM from './assets/image/enroll/group-m.png'

let mediaPhone = window.matchMedia('(min-width: 320px) and (max-width: 480px)').matches

let cocoLink = process.env.VUE_APP_COCO_LINK
let cocoProxyLink = process.env.VUE_APP_COCO_PROXY_LINK
let ozariaLink = process.env.VUE_APP_OZARIA_LINK || 'http://staging.aojiarui.com'
let provider = process.env.VUE_APP_PROVIDER
let Oprovider = process.env.VUE_APP_PROVIDER_O

let cocoClan1 = process.env.VUE_APP_COCO_CLAN_1
let cocoClan2 = process.env.VUE_APP_COCO_CLAN_2
let cocoClan2021 = process.env.VUE_APP_COCO_CLAN_2021
let teacherClan = process.env.VUE_APP_TEACHER_CLAN

let cocoTour1 = process.env.VUE_APP_COCO_TOUR_1 || '601e1657120e5b0028ebabba'
let cocoTour2 = process.env.VUE_APP_COCO_TOUR_2 || '601e16d9120e5b0028ebabc4'

console.log(ozariaLink)
let redirect = process.env.VUE_APP_REDIRECT
let statisticCode = process.env.VUE_APP_STATISTICS

let loginLink = cocoLink + '/auth/login-o-auth?provider=' + provider
let loginOzaria = ozariaLink + '/auth/login-o-auth?provider=' + provider
let clanLink = '/play/ladder/infinite-inferno/clan/'

let gd2link = '/play/level/game-dev-2-final-project?course=57b621e7ad86a6efb5737e64&course-instance='
let cs2link = '/play/562f88e84df18473073c74e2?course=5632661322961295f9428638&course-instance='
let rtlink = '/play/level/resource-tycoon?codeLanguage='

export default new Vuex.Store({
  state: {
    timeDelay: 0,
    procedure: 1, 
    game_slug: '2022-1',
    loginLink: loginLink,
    gamelink: loginLink + '&accessToken=',
    gd2link: gd2link,
    cs2link: cs2link,
    rtlink: rtlink,
    ozarialink: loginOzaria + '&accessToken=',
    cocoLink: cocoLink,
    statisticCode: statisticCode,
    mediaPhone: mediaPhone,
    noHeader: false,
    noFooter: false,
    classrooms: [],
    allScore: [],
    auth: {
      user: null,
      token: null,
      classroom: {},
      game_state: {},
      csrf: ''
    },
    route: {
      redirect: ''
    },
    input: {
      enroll: {
        area: {province: '北京', id: 1, city: '东城'},
        group: 0,
        invite: '',
        lang: 'python'
      }
    },
    'hbar': {
      'links': [{text: '首页', link: {name: 'frontpage'}},
                // {text: '开始比赛', link: {name: 'PlayPage', params: { slug: 'pre'}}},
               ],
      'login': {text: '登录', link: {name: 'account', params: {type: 'login'}}},
    },
    'sbar': {
      'linksFP': [
        // {text: '开始报名', link: {name: 'enroll'}, disable: false},
                  {text: '开始比赛', link: {name: 'Preliminary'}},
                  // {text: '查看成绩', link: {name: 'score'}},
                  {text: '常见问题', link: {name: 'problem'}},
                  ],
      'linksRule': [
        // {text: '开始报名', link: {name: 'enroll'}},
                    // {text: '开始比赛', link: {name: 'Preliminary'}},
                    // {text: '查看成绩', link: {name: 'score'}},
                    // {text: '规则下载', link: '/oss/pdf/%E2%80%9C%E6%89%A3%E5%93%92%E6%9D%AF%E2%80%9D%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E5%A4%A7%E8%B5%9BAI%E4%B8%96%E9%9D%92%E8%B5%9B%E8%A7%84%E5%88%99.pdf'}
      ]
    },
    'news': {
      news: []
    },
    'problem': {
      questions: [
{question: '本届大赛的主办方是谁？', answer: '少年硅谷AI算法竞技赛是由教育部批准的白名单赛事，由中国下一代教育基金会主办，扣哒世界作为AI算法竞赛赛独家技术平台为大赛提供技术支持。'},
{question: '本届大赛的目标是什么？', answer: '少年硅谷AI算法竞技赛以“科技强国.未来有我”为主题，以“坚持立德树人，培养具有家国情怀，崇尚科学的好少年”为目标，彰显公益普惠风尚，助力深化教育改革，全面实施素质教育。'},
{question: '本届大赛收费吗？', answer: '少年硅谷AI算法竞技赛是公益竞赛，不收报名费，0基础、0门槛参赛。'},
{question: '本届大赛参赛学段有哪些？', answer: '小学、初中、高中（含中职）。'},
{question: '选手的参赛年龄有限制吗？', answer: '对于小学、初中、高中（含中职）学段适龄学生皆可报名。'},
{question: '如何报名？', answer: '参赛选手需要在AI算法竞技赛官网报名参加省级选拔赛，入围全国决赛的晋级选手还需要在第二届（2021-2022学年) 全国青少年人工智能教育成果展示大赛 官网注册，便于获奖证书登记和发放。'},
{question: '报名注册遇到问题怎么联系组委会？', answer: '您可以关注网站底部微信公众号，在后台留言或者提问， 也可以扫描首页左侧微信客服二维码，或给组委会客服人员发电子邮件，邮箱为chenrun@codecombat.com'},
{question: '比赛共分几轮？', answer: '本届比赛分为省级选拔赛和全国决赛。省级选拔赛分为省级初赛和复赛，全国决赛结束后对于排名前5%的优秀选手还将进行一场金牌附加赛，一共有四轮选拔。'},
{question: '省级比赛考核哪些内容？', answer: '省级初赛将以扣哒世界算法竞技场形式，难度为计算机科学一级～二级(CS1-CS2) 难度，省级复赛以扣哒世界游戏开发形式，难度为游戏开发一级 ~ 二级 (GD1-GD2) 难度。主要考核学生运用计算机程序语言进行算法设计的能力。'},
{question: '为什么要选用《冰锋竞速》作为初赛算法竞技场？', answer: '选择《冰锋竞速》是致敬2022年北京冬奥会，算法竞技和体育竞技一样，需要在瞬息万变的赛场上从容应对的智慧，日复一日不断练习坚忍不拔的毅力。致敬并学习冬奥会上那些了不起的英雄，激发选手成为算法设计和科技创新方面的英雄。'},
{question: '省级比赛可以参考哪些教材或内容？', answer: '省级初赛和复赛都是以扣哒世界平台为中心，我们建议选手围绕扣哒世界计算机科学入门、计算机科学2、游戏开发1和游戏开发2来进行学习和练习。'},
{question: '全国决赛考核哪些内容？', answer: '全国决赛以扣哒世界算法竞技场形式，难度为计算机科学三级～四级(CS3  CS4) 难度。金牌附加赛将采用限时闯关的形式考核学生对人工智能算法的灵活掌握程度。'},
{question: '竞赛程序语言可以选择哪些？', answer: 'Python, C++, JavaScript任意一种语言。'},
{question: '如何知道自己的排名？', answer: '选手账户未登录竞赛网站时，仅可查看全国排名（各组别前100名），登录后可查看按省级排名情况。'},
{question: '如何提高自己的排名？', answer: '建议选手挑战排名比自己靠前的对手并击败他/她。'},
{question: '需要实名注册吗？', answer: '需要，奖状选手名字和注册名字需要一致。'},
{question: '有哪些学习资源可以参考？', answer: '选手可以在<a target="_blank" href="https://koudashijie.com">扣哒世界 (koudashijie.com)</a>和<a target="_blank" href="https://codecombat.cn">CodeCombat (codecombat.cn)</a>上练习，循序渐进学习人工智能算法知识。如果需要高水平的教练指点，可以在<a target="_blank" href="https://xuetang.koudashijie.com">扣哒学堂</a>预约清华北大优秀竞赛教练指导。'},
      ]
    },
    'resources': [
      {name: '扣哒学堂', desc:'清北教练指导', link: 'https://xuetang.koudashijie.com'},
      {name: '极客战记', desc:'个人关卡练习', link: 'https://codecombat.cn'},
      {name: '扣哒世界', desc:'班级关卡学习', link: 'https://koudashijie.com'},
    ],
    'score': {
      myrank: [],
      rank: {
        title: ['排名', '姓名', '冰锋竞速积分', '省市'],
        school_title: ['排名', '学校/机构', '逃出地牢积分',  '巫师之战积分', '总积分'],
        infos: {
          's1': [
            [1, '陈木夕', '123', '山西省运城市']
          ],
          's2': [
            [3, '李子旋', '120', '山西省运城市']
          ],
          'm': [
            [3, '杨依然', '120', '山西省运城市']
          ]
        }
      },
      finalRank: {
        title: ['排名', '昵称', '积分', '省市'],
        school_title: ['排名', '学校/机构', '总积分'],
      }
    },
    'aboutus': {
      'desc': [
        '本赛事为教育部白名单赛事之一，0报名费、0门槛、0基础的公益科普赛事，扣哒世界作为大赛技术支持平台承担竞赛内容开发和实施任务，本次大赛以“科技强国 未来有我”为主题，以“坚持立德树人，培养具有家国情怀、崇尚科学的好少年”为目标，以“弘扬新时代北斗精神、彰显公益普惠风尚、助力深化教育改革”为宗旨，面向全国中小学生，组织开展适合少年儿童特点，富有创新性、示范性和导向性的科技教育竞赛和展示活动，为少年儿童创造学习科技、交流成果、展示技能的舞台，为学校和教师提供科技教育互相学习、交流探讨、提升的契机，为科技企业和机构搭建集中展示、交流互鉴、分享合作的平台。'
        // '2021-2022赛季“扣哒杯”AI世青赛是由扣哒人工智能学院、CodeCombat和网易伏羲人工智能实验室联合主办，全球数十家STEAM/青少年编程教育机构和知名院校联合协办或积极参与的科普公益赛事，2021年9月20日全球启动。',
        // '本次赛事秉承科普和公益的原则，不收取报名费用，组委会将向全球贫困地区农村学校捐赠编程和人工智能基础课程。'
      ],
      'org': {
        'title': '大赛组织结构',
        'info': {
          '批准单位': ['教育部'],
          '主办单位': ['中国下一代教育基金会', '扣哒世界' ],
          '技术平台': ['扣哒世界'],
          '协办单位': ['斯坦星球', '扣哒数字少年', '华中师大一附中等'],
          '学术合作':[ '北京大学', '清华大学'],
          '教学平台':['扣哒学堂']
        }
      },
      'support': {
        'title': '大赛组织委员会',
        'info': {
          '' : ['少年硅谷AI算法竞技赛组委会负责本次大赛的线上组织、宣传、推广、指导和落地工作。组委会秉承本届赛事公平、公正、公益原则，履行大赛职责，服务参赛选手。对于赛事结果的申诉，可以在比赛后4个小时内通过电子邮件的方式向大赛组委会申诉。'],
          '大赛组委会邮箱': ['china@codecombat.com'],
          // '客服QQ': ['1011635189']
        }
      },

      ptable: {
        titles: [{text: '省/直辖市', w: '6vw'},
                 {text: '市', w: '6vw'},
                 {text: '大赛服务协办点', w: '16vw'},
                 {text: '电话', w: '12vw'},
                 {text: '地址', w: '22vw'},
                 {text: '详细介绍', w: '6vw'}],
        infos: [
          ['深圳市', '龙岗区', '编玩时光教育科技有限公司', '13316924697(周)', '深圳市龙岗区布吉街道布沙路佳兆业可园6A-603'],
          ['辽宁省', '沈阳', '华斯教育信息咨询有限公司', '13998300199(王)', '辽宁省沈阳市沈河区佳兆业大厦C座1807'],
          ['四川省', '成都', '酷思未来教育科技有限公司', '028-67876390(张)', '四川省成都市锦江区晨辉二街26号'],
          ['重庆市', '渝北区', '图灵教育科技有限公司', '023-65552278', '重庆市渝北区金童路100-5-4'],
          ['浙江省', '杭州', '码爸爸编程创客中心', '18969090235(刘)', '杭州上城区富春路132号昆仑中心A座6楼'],
          ['福建省', '福州', '一瓦教育科技有限公司', '0591-86129060(陈)', '福州市五四路环球广场5楼 '],
          ['山东省', '青岛市', '青岛极客启明星青少年编程学校', '13365321791(李)', '青岛市市南区动漫产业园A座209B'],
          ['宁夏', '银川', '智途教育信息咨询有限公司', '18995089318(何)', '银川市金凤区凤凰北街天玺国际B北座532']
        ],
        details: [
          ['深圳市编玩时光教育科技有限公司，成立于2016年，由毕业于中山大学计算机专业的周老师发起创建，旨在让中国学生的编程学习多些快乐，少些弯路。',
           '”乐码无派”既是我们的品牌标识，又是我们的教学理念，即：快乐编码、无派无界，我们期望让少儿编程多些中国色，以”编程”为主线，教授孩子更多的知识与道理。',
           '编程是孩子未来发展的关键变量，编程教育的早接触、早学习，已是各国的普遍共识，欢迎加入乐码无派少儿编程俱乐部，一起探索神秘的编程世界吧！'],
          ['华斯教育得名于中国及斯坦福大学 ，旨在培养国际化人才。创始人毕业于斯坦福大学，团队成员来自欧美顶尖学府，致力于为中国教育产业注入国际尖端教育产品，为中国及世界输出具有国际视野的青少年。'],
          ['酷思少儿编程——四川省嘉祥教育集团旗下少儿编程教育专业领导品牌，专注为中国5-12少儿提供全球最先进的编程教育，帮助孩子应对未来挑战，在世界舞台脱颖而出。',
           '以美国CSTA(中小小学计算机科学教学)标准为基石，原版引起美国Workshop、日本Sony Education等全球最先进少儿编程课程体系。'],
          ['重庆图灵教育科技有限公司是一家由资深教育人士全力打造的，致力于STEAM教育的专业教育集团。现专注于少儿编程教育，独家引进了拥有1200万学习者的全球青少年Python编程第一品牌CodeCombat，面向全社会广泛招生。'],
          ['国际科技创新联盟会员单位',
           '美国大学理事会认证的青少年编程教育平台CodeCombat的核心合作伙伴',
           '码爸爸编程创客中心致力于为孩子们打造符合欧美K-12教育体系、新一代人工智能发展规划以及新高考自主招生等教育领域发展平台，实现孩子们的信息素养与Steam教育破冰，携手孩子和家长迈入面向2025后的全球化教育目标！'],
          ['一瓦少儿编程由深耕行业多年的STEAM教育专家创立运营，引进欧美先进教育理念和课程平台，致力于打造成为青少年人工智能素质培育中心。专注7-16岁青少年人工智能通识教育，让孩子从编程开始编写未来。'],
          ['青岛极客启明星青少年编程学校成立于2016年，是青岛第一家以青少年编程课程为主的专业学校，以全国青少年信息学奥赛（NOIP）和全国中小学生科技创新与实践活动（NOC）辅导为核心课程。我们联合大学的专业师资力量，针对中小学生量身定制辅导竞赛类课程，旨在竞赛中获取奖项，增强孩子们的竞争优势，参加中高考自主招生及综合评价招生，提高孩子逻辑思维能力、及综合学科素质能力。'],
          ['宁夏智途教育信息咨询有限公司（蒸汽创客SteamLeader）致力于基于STEAM的青少年编程创客教育，是宁夏第一家编程教育培训公司，目前团队有35人，在长期读学生500余人，以编程入校形式和宁夏42家重点中小学长期合作，承办了宁夏地区青少年创意编程与智能设计大赛、蓝桥杯、NOC创意编程大赛、科技创新大赛编程赛项等多个地区权威比赛。']
        ]
      }
    },
    'enroll': {
      areas: {},
      groups: [
        {text: '小学组', key: 's', extra: '（1-6年级）', img: groupS1},
        {text: '初中组', key: 'm', extra: '.', img: groupS2},
        {text: '高中组', key: 'l', extra: '（含中职）', img: groupM},
      ],
      egroup: {text:'教师组', key: 't', extra: '.'},
      languages: ['python', 'javascript', 'c++'],
      notice: [
               '1. 活动分为小学组（1-6年级）、中学组（初中、高中）以及开放组。\n编程零基础也可参赛。 注：参赛选手年级以2021年9月1日入学后的年级为准，上海地区六年级参赛同学请选择初中组。',
               '2.大赛指定时间内，注册进入报名入口即可开始挑战，初赛结束前可反复挑战。',
               '3.比赛必须通过本网站进入挑战游戏页面，其他路径进入成绩无效。',
               '4.如果报名信息有误，申请修改资料，请扫描网页底部微信公众号二维码咨询。',
               '5.报名时间截止为6月14日 23:59。'
              ],
      link: cocoProxyLink + '/account/oauth-aiyouth?provider=' + provider + '&token='
    },
    'account': {
      'register': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '去登录', link: {name: 'account', params: {type: 'login'}}}
        ],
        'forms': [
          {label: 'phone', type:'text', placeholder: '请填写 11 位手机号'},
          {label: 'code', type:'text', placeholder: '请输验证码'},
          {label: 'name', type:'text', placeholder: '输入真实姓名'},
          {label: 'password', type:'password', placeholder: '请输入密码，长度6位以上'},
          {label: 'password_confirmation', type:'password', placeholder: '请确认密码'},
        ]
      },
      'certification': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '退出登录', link: ''}
        ],
        'forms': [
          {label: 'name', type: 'text', placeholder: '真实姓名'},
          {label: 'idcard', type: 'text', placeholder: '身份证号'},
          {label: 'organization', type: 'text', placeholder: '参赛单位（选填）'},
        ]
      },
      'modifyInfo': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '退出登录', link: ''}
        ],
        'forms': [
          {label: 'teacher', type: 'text', placeholder: '指导老师'},
          {label: 'organization', type: 'text', placeholder: '学校/机构'},
        ]
      },
      'password': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '退出登录', link: ''}
        ],
        'forms': [
          {label: 'password', type: 'password', placeholder: '请输入新密码，长度6位以上'},
          {label: 'password_confirmation', type: 'password', placeholder: '请重复一遍密码'}
        ]
      },

      'login': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '去注册', link: {name: 'account', params: {type: 'register'}}, disable: true}
        ],
        'forms': [
          {label: 'phone', type: 'text', placeholder: '报名ID'},
          {label: 'password', type: 'password', placeholder: '请输入密码'}
        ]
      },
      'loginWithCode': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '去登录', link: {name: 'account', params: {type: 'login'}}}
        ],
        'forms': [
          {label: 'phone', type: 'text', placeholder: '手机号'},
          {label: 'code', type: 'text', placeholder: '请输入验证码'}
        ]

      }
    },
    'frontpage': {
      'title': {
        main: '春华秋实  （绿色能源）',
        sub: '2023-2024 全国青少年劳动技能与智能设计大赛',
        button: 'end'
      },
      'info': {
        'activity': {
          'content': {
            title: '活动介绍',
            text: '为深入贯彻落实国务院《新一代人工智能发展规划》的任务要求，逐步开展全民智能教育项目、普及推广编程教育，提高我国全民对人工智能的认知和初步应用能力。培养复合型人才，形成我国人工智能人才高地，并积极培养新一代适应社会发展的人才。赛迪研究院培训中心联合CodeCombat共同举办赛迪人工智能大赛，并于2019年开展首届青少年编程组挑战活动(以下简称“活动”)。'
          },

          'style': {
            content: {
              'box-sizing': 'border-box',
              width: mediaPhone? '100vw':'66.56vw',
              height: mediaPhone? '29.75vw': '19.8vw',
              // 'background-image': 'url('+require('./assets/image/frontpage/info-activity.png')+')',
              'background-image': 'url("/oss/images/frontpage/info-activity.png")',
              'background-size': mediaPhone? '100vw':'66.56vw',
              padding: '3.6vw 10.4vw',
              'font-size': mediaPhone? '1.8vw': '0.9375vw'
            }
          }
        },
        orgStyle: {
          content: {
            'box-sizing': 'border-box',
            width: mediaPhone? '28vw': '19vw',
            height: mediaPhone? '37.08vw': '25.16vw',
            padding: '2.5vw',
            'justify-content': 'flex-start'
          },
          logoDiv: {
            'height': '4.2vw'
          },
          title: {
            'font-size': mediaPhone? '2vw' : '1vw',
            'position': 'absolute',
            top: '8vw',
            'background-image': 'none',
            width: '100%'
          },
          text: {
            'font-size': mediaPhone? '1.6vw': '0.9vw',
            'margin-top': '5vw'
          }
        }
      },
      rewards: [
        {
          color: '#9046CF',
          icolor: '#EFBB24',
          icon: 'medal',
          title: '金牌',
          subTitle: '5 名',
          content: '2000元扣哒之星夏令营奖学金'
        },
{
          color: '#CC59D2',
          icolor: '#91989F',
          icon: 'medal',
          title: '银牌',
          subTitle: '10 名',
          content: '1500元扣哒之星夏令营奖学金'
        },
{
          color: '#F487B6',
          icolor: '#A28C37',
          icon: 'medal',
          title: '铜牌',
          subTitle: '20 名',
          content: '1200元扣哒之星夏令营奖学金'
        },
{
          color: '#FAE3C6',
           icolor: '#EFBB24',
          icon: 'award',
          title: '一等奖',
          subTitle: '前20%',
          content: '1000元扣哒之星夏令营奖学金'
        },
{
          color: '#FDE12D',
          icolor: '#91989F',
          icon: 'award',
          title: '二等奖',
          subTitle: '前20%-50%',
          content: '800元扣哒之星夏令营奖学金'
        },
{
          color: '#6CCFF6',
          icolor: '#A28C37',
          icon: 'award',

          title: '三等奖',
          subTitle: '前50%-90%',
          content: '500元扣哒之星夏令营奖学金'
        },

      ],
      highlights: {
        images: [
          {
            desc: '教育部白名单赛事',
            src: '/oss/aialgorithm/images/frontpage/pic-hl0.png'},
          {
            desc: '零基础 零报名费',
            src: '/oss/images/frontpage/pic-hl1.jpg'
          },
          {
            desc: '人工智能通识基础',
            src: '/oss/images/frontpage/pic-hl2.png'
          },
          {
            desc: '以赛促学 编程竞技',
            src: '/oss/images/frontpage/pic-hl3.png'
          },
          {
            desc: '全球视野 中西贯通',
            src: '/oss/images/frontpage/pic-hl4.png'
          },
          {
            desc: '全球编程等级证书',
            src: '/oss/images/frontpage/pic-hl5.jpg'
          },
          {
            desc: '公益助学贫困学校',
            src: '/oss/images/frontpage/pic-hl6.jpg'
          },
          {
            desc: '直通硅谷 名校研学',
            src: '/oss/images/frontpage/pic-hl7.png'
          }
        ],
        bgStyle: {
          width: mediaPhone? '20vw': '14.43vw',
          'background-size': mediaPhone? '20vw': '14.43vw',
          height: mediaPhone? '15.5vw': '11.2vw'
        }
      },
      process: [
        {
          time: {
            year: '2022年',
            date: '3.1-6.15'
          },
          event: {
            main: '省级初赛',
          }
        },{
          time: {
            year: '2022年',
            date: '6.20-6.27'
          },
          event: {
            main: '省级复赛',
          }
        }, {
          time: {
            year: '2022年',
            date: '7.5-7.30'
          },
          event: {
            main: '全国决赛',
            // sub: '及颁奖典礼'
          }
        },
      ],
      detail: {
        content: {
          title: '比赛详情',
          text: [
            '本次比赛为少年硅谷AI算法竞技赛，分为选拔赛（省级初赛和复赛）、全国决赛。',

            '省级初赛0基础参赛，以赛促学。通过学习扣哒世界计算机科学一 （CS1)，积累相关的编程基础知识和算法设计，并在Wakka Maul算法竞技场进行赛前练习。然后参加初赛竞技场《冰锋竞速》(Iron and Ice)完成挑战，选手需要获得正分才能晋级省级复赛。',
            '省级初赛考察知识点包括对象、方法、参数、变量、循环、字符串、条件语句、函数以及算法设计、策略优化等。',
            '省级初赛支持Python、 C++和JavaScript三种代码语言。'
          ]
        },

        style: {
          content: {
            // 'background-image': 'url('+require('./assets/image/frontpage/sbg-detail.png')+')',
            'background-image': 'url("/oss/images/frontpage/sbg-detail.png")',
            'box-sizing': 'border-box',
            'background-size': '100vw',
            width: '100vw',
            height: '30.02vw',
            padding: '4vw 22.5vw 4vw 24vw',
            'justify-content': 'flex-start'

          },
          title: {
            color: '#6C4DFF'
          },
          text: {
            'margin-top': '1.8vw',
            color: '#4D4D4D'
          }
        },
        images: [
          detailImg0, detailImg1, detailImg2,
          detailImg3, detailImg4, detailImg5
        ]
      },

      videos: [
        {
          src: '/oss/videos/2021/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91%E5%B7%A6-AI%E4%B8%96%E9%9D%92%E8%B5%9B2021%E5%AE%A3%E4%BC%A0.mp4',
          title: '扣哒杯AI世青赛2021宣传片',
          poster: '/oss/images/frontpage/2021/2021%E5%AE%A3%E4%BC%A0%E7%89%87.png'
        },
        {
          src: '/oss/videos/2021/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91%E4%B8%AD-%E8%8B%8F%E5%B7%9E%E5%B8%82%E9%9D%92%E5%B0%91%E5%B9%B4%E7%A7%91%E6%8A%80%E8%8A%82.mp4',
          title: '苏州市青少年科技节',
          poster: '/oss/images/frontpage/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4%E5%8A%A9%E5%8A%9B%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2.jpg'
        },
        {
          src: '/oss/videos/2021/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91%E5%8F%B3-%E5%A6%82%E4%BD%95%E5%8F%82%E5%8A%A0AI%E4%B8%96%E9%9D%92%E8%B5%9B2021.mp4',
          title: '如何参加AI世青赛和闯关竞技',
          poster: 'https://assets.koudashijie.com/aiyouth/images/frontpage/video_3_poster.png'
        }
      ]
    },
    'footer': {
      main: {
        title: '主办单位',
        info: [{
          name: '中国下一代教育基金会',
          link: 'http://www.cngef.org.cn/'
        },
        ]
      },
      support: {
        title: '技术支持单位',
        info: [{name: '扣哒世界', link: 'https://koudashijie.com'}] //, '扣哒学堂', 'CodeCombat']
      },
      contact: {
        title: '联系我们',
        info: {
          '联系客服': '见右侧微信客服',
          '工作时间': '周一～周五9:00 – 17:00，法定节假日除外',
          '单位地址': '北京市丰台区马家堡东路168号14号楼1单元1604室',
          // '客服QQ': '1011635189'
        }
      }
    },
    'bbar': {},
    'logo': {
      'main': {text: 'AI世青赛', icon: mainLogo},
      'mainBlack': {text: 'AI世青赛', icon: mainLogoBlack},
      'ccid': {text: '赛迪研究院培训中心', icon: ccidLogo},
      'ccia': {text: '中国行业计算机协会', icon: cciaLogo},
      'ccidRed': {text: '赛迪研究院培训中心', icon: ccidLogoRed},
      'coco': {text: 'CodeCombat', icon: cocoLogo},
      'raic': {text: 'RAIC雷克大会', icon: raicLogo},
      'fxWhite': {text: '伏羲人工智能实验室', icon: fxLogoWhite},
      'kdsj': {text: '扣哒世界', icon: '/oss/logos/kdsj.jpg'},
      'kdxt': {text: '扣哒学堂', icon: '/oss/logos/kdxt.png'},
      'sngg': {text: '少年硅谷', icon: snggLogo},
      'hsjy': {text: '', icon: hsjyLogo},
      'ks': {text: '', icon: ksLogo},
      'mbb': {text: '', icon: mbbLogo},
      'rmwp': {text: '', icon: rmwpLogo},
      'tl': {text: '', icon: tlLogo},
      'yw': {text: '', icon: ywLogo},
      'zqck': {text: '', icon: zqckLogo},
      'qmx': {text: '', icon: qmxLogo}
    },
    'copyright': 'Copyright @2021 CodeCombat ALL Right Reserved.'
  },
  getters: {
    clanLinks: state => {
      return clanLink + cocoClan2021
    },
    organizers: state => {
      return [
        {
          content: {
            logo: state.logo.kdxt,
            title: '扣哒人工智能学院',
            text: '扣哒人工智能教育与全球顶级学府和顶级AI机构合作，为青少年学习编程和人工智能技术定制的优质平台。',
            link: 'https://koudashijie.com/'
          },
          style: {
            content: Object.assign({
              'background': 'linear-gradient(51.7deg, #ee7151, #F1934b)'
            }, state.frontpage.info.orgStyle.content),
            logoDiv: state.frontpage.info.orgStyle.logoDiv,
            logo: {width: '11vw'},
            title: state.frontpage.info.orgStyle.title,
            text: state.frontpage.info.orgStyle.text
          }
        },
        {
          content: {
            logo: state.logo.coco,
            title: 'CodeCombat',
            text: 'AP认证全球广受欢迎的青少年编程教学和学习平台，覆盖全球200多个国家近2000万学习者。',
            link: 'https://codecombat.com/'
          },
          style: {
            content: Object.assign({
              background: 'linear-gradient(51.7deg, rgb(244, 199, 20), rgb(244, 168, 10))'
            }, state.frontpage.info.orgStyle.content),
            logoDiv: state.frontpage.info.orgStyle.logoDiv,
            logo: {width: '11.875vw'},
            title: state.frontpage.info.orgStyle.title,
            text: state.frontpage.info.orgStyle.text
          }
        },
        {
          content: {
            logo: state.logo.fxWhite,
            title: '网易伏羲实验室',
            text: '网易伏羲实验室是国内首家专业游戏AI研究机构，旨在运用人工智能尖端科技为用户营造新时代的技术体验。',
            link: 'https://fuxi.163.com'
          },
          style: {
            content: Object.assign({
              background: 'linear-gradient(51.7deg, #4ab593, #95e18e)'
            }, state.frontpage.info.orgStyle.content),
            logoDiv: state.frontpage.info.orgStyle.logoDiv,
            logo: {width: '11.875vw'},
            title: state.frontpage.info.orgStyle.title,
            text: state.frontpage.info.orgStyle.text
          }
        },
        /*{
          content: {
            logo: state.logo.raic,
            title: 'RAIC雷克大会',
            text: '雷克(RAIC)是工业和信息化部中国电子信息产业发展研究 院聚焦人工智能领域的新锐品牌。该品牌以人工智能产业创新联盟为依托，成功举办多届雷克大会。现已成为人工智能领域顶尖专 家学者和行业领袖交流研讨、思想激荡的高端平台。',
            link: 'http://www.raictech.com/'
          },
          style: {
            content: Object.assign({
              background: 'linear-gradient(51.7deg, #6442ff, #669ef2)'
            }, state.frontpage.info.orgStyle.content),
            logoDiv: state.frontpage.info.orgStyle.logoDiv,
            logo: {width: '7.55vw'},
            title: state.frontpage.info.orgStyle.title,
            text: state.frontpage.info.orgStyle.text
          }
        }*/
      ]
    },
    coorgLogos: state => {
      let logoList = [
        'stxq.jpg',
        'kdszsn.png',//扣哒数字少年
        'gaodele.jpeg',
        'zhsd.png',//智航时代
        //甘肃扣哒
        'szdc.png', //苏州青少年数字公民培育计划
        'bjjqr.png',
        'mkjy.jpg',
        'mabb.png',
        'dmbl.png',//代码部落
        'angli.png',//小灵狐教育
        'zqck.png',
        'kdck.jpg',
        // 'kdck.png',
        'szzx.png',
        'hsdyfz.png', //华中师大一附中
        'zxzx.jpg',
        'xazx.png'



        // 'xadc.jpg',
        // 'tuling.png',
        // 'beike.png',
        // 'kusi.png',
        // 'qihang.png',
        // 'Al4kids.png',
        // 'jikeqmx.jpeg',
        // 'codewall.png',
        // 'lechuang.png',
        // 'cct.png',
        // 'hsjy.png',
        // 'lsyz.jpeg',
        // 'lexue.jpeg',
        // 'ing.png',
        // 'micei.png',
        // 'youfa.png',
        // 'abilix.jpeg',
        // 'kdbc.png',
        // 'aosong.png',
        // 'MrHow.jpeg',
        // 'mmyc.png',
        // 'kdbc.jpg',
        // 'wljy.png',
        // 'dshzx.png',
        // 'sqwgy.jpg',
        // 'jlzx.png',
        // 'hzzx.png',
        // 'hdwgy.png',
        // 'xalzfx.png',
        // 'xazx.png',
        // 'wlkjxx.png'
      ]
      return logoList.map(d => { return {icon: '/oss/logos/' + d}})
      // return [
      //   state.logo.tl,
      //   state.logo.hsjy,
      //   state.logo.ks,
      //   state.logo.mbb,
      //   state.logo.rmwp,
      //   state.logo.yw,
      //   state.logo.zqck,
      //   state.logo.qmx
      // ]
    }
  },
  mutations: {
    SET_USER(state, user) {
      state.auth.user = user
    },
    SET_TIME(state, time) {
      state.timeDelay = time
    },
    SET_CLASSROOMS(state, classrooms) {
      state.classrooms = classrooms
    },
    SET_MY_CLASSROOM(state, classroom) {
      state.auth.classroom = classroom
    },

    SUCCESS_ENROLLED(state) {
      state.auth.user.enrolled = true
    },
    SET_TOKEN(state, token) {
      state.auth.token = token
    },
    LOGOUT(state) {
      state.auth.user = null
      state.auth.token = ''
    },
    updateEnrollProvince(state, pay) {
      state.input.enroll.area.province = pay.p
      state.input.enroll.area.id = pay.id
    },
    updateEnrollCity(state, c) {
      state.input.enroll.area.city = c
    },
    updateEnrollInvite(state, i) {
      state.input.enroll.invite = i
    },
    updateEnrollOrg(state, i) {
      state.input.enroll.organization= i
    },
    updateEnrollTeacher(state, i) {
      state.input.enroll.teacher = i
    },
    updateEnrollIdCard(state, i) {
      state.input.enroll.idcard = i
    },
    updateEnrollGroup(state, g) {
      state.input.enroll.group = g
    },
    updateEnrollLang(state, l) {
      state.input.enroll.lang = l
    },
    SET_REDIRECT(state, path) {
      state.route.redirect = path
    },
    UNSET_REDIRECT(state) {
      state.route.redirect = ''
    },
    SET_MEDIAPHONE(state, b) {
      state.mediaPhone = b
    },
    SET_GAME_STATE(state, g) {
      state.auth.game_state = g
    },
    SET_GAME_YEAR(state, y) {
      state.game_year = y
    },
    SET_ALL_SCORE(state, a){
      state.allScore = a
    },
    SET_PROCEDURE(state, b) {
      state.procedure = b
    },
    SET_GAME_SLUG(state, b) {
      state.game_slug = b
    },
    SET_HEADER(state, h) {
      state.noHeader = !h
    },
    SET_FOOTER(state, f) {
      state.noFooter = !f
    }
  },
  actions: {},
  plugins: [createPersistedState({
    key: 'aiyouth',
    paths: ['auth', 'timeDelay'],
    storage: window.localStorage
  })]
})
